exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HelpSectionDesktop__column___25LqR > div:not(:last-child) {\n  margin-bottom: 16px;\n  margin-top: 12px; }\n\n.HelpSectionDesktop__column___25LqR > a {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 21px;\n  opacity: 65%;\n  color: rgba(0, 0, 0, 0.5); }\n  .HelpSectionDesktop__column___25LqR > a:hover {\n    color: #f94144; }\n", ""]);

// exports
exports.locals = {
	"column": "HelpSectionDesktop__column___25LqR"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/Footer/HelpSectionDesktop/HelpSectionDesktop.scss
// module id = 2089
// module chunks = 6